import gql from 'graphql-tag';
import { ZapierClient } from 'graphql/clients';
import { CurrentUser } from './types';

const CurrentUserQuery = gql`
  query CurrentUserV2 {
    currentUserV2 {
      isStaff
    }
  }
`;

async function fetchCurrentUser() {
  const { data } = await ZapierClient.query<CurrentUser>({
    query: CurrentUserQuery,
  });

  return data;
}

export const fetchIsStaff = async (): Promise<boolean> => {
  const user = await fetchCurrentUser();

  return user?.currentUserV2?.isStaff || false;
};
